import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const updateCommentarySection = api(async function updateCommentarySection({ id, title, description, content }) {
    return mutate(
        gql`
            mutation UpdateCommentarySection($id: String!, $title: String!, $description: String, $content: String) {
                updateCommentarySection(id: $id, title: $title, description: $description, content: $content)
            }
        `,
        { id, title, description, content },
        { returns: "updateCommentarySection" }
    )
})
